import React from "react";

const CustomerUserView = () => null;

export default CustomerUserView;
